































































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import axios from 'axios';

@Component({})
export default class Edit extends BaseFormEdit {
  form = {
    login: '',
    impersonateOrganizationId: '',
    name: '',
    email: '',
    phone: '',
    additionalPhone: '',
    note: '',
    post: '',
    organization: '',
    organizationCode: '',
    isLocked: false,
    showNotifications: false
  } as any;

  data = { impersonateOrganizations: [] } as any;

  protected created() {
    const self = this;
    axios
      .get('/Dictionary/GetImpersonateOrganizations')
      .then((response) => {
        self.data.impersonateOrganizations = response.data;
      })
      .catch(() => {});
  }
}
